import { createAsyncThunk } from "@reduxjs/toolkit";

import * as URL from "../../helpers/url_helper";

import { get, post, put, del } from "../../helpers/api_helper";

export const getCategory = createAsyncThunk(
  "getCategory",
  async ({ data, callback }, Thunk) => {
    try {
      // const queryParams = new URLSearchParams(data).toString();
      //const url =                      //`${URL.GET_CATEGORY}?${queryParams}`;
      let response = await post(URL.GET_CATEGORY, data);
      callback && callback(null, response.data);
      return response;
    } catch (error) {
      callback && callback(error?.data?.message || error.message || error);
      return Thunk.rejectWithValue(error);
    }
  }
);

export const addCategory = createAsyncThunk(
  "addCategory",
  async ({ data, callback }, Thunk) => {
    try {
      let response = await post(URL.ADD_CATEGORY, data);
      callback && callback(null, response);
      return response;
    } catch (error) {
      callback && callback(error?.data?.message || error.message || error);
      return Thunk.rejectWithValue(error);
    }
  }
);
export const editCategory = createAsyncThunk(
  "editCategory",
  async ({ data, callback }, Thunk) => {
    try {
      let response = await put(URL.EDIT_CATEGORY + data?._id, data);
      callback && callback(null, response);
      return response;
    } catch (error) {
      callback && callback(error.message, null);
      return Thunk.rejectWithValue(error);
    }
  }
);

export const deleteCategory = createAsyncThunk(
  "deleteCategory",
  async ({ data, callback }, thunkAPI) => {
    console.log(data, "data++=++++++++++++++++++++");
    try {
      const response = await del(URL.DELETE_CATEGORY + data);
      console.log(data, "data----------->");
      callback && callback(null, response);
      return response;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");

      return thunkAPI.rejectWithValue(error);
    }
  }
);
